(() => {
  'use strict';
  const selector = '.productView-nav[data-image-gallery-main]:not(.productView-nav-gallery)';
  let queued = false;
  const widths = new WeakMap();
  const loadedGalleries = new WeakSet();
  const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(entries => {
    let changed = false;
    for (const entry of entries) {
      const width = entry.contentRect.width;
      if (Math.abs((widths.get(entry.target) || 0) - width) > 1) {
        widths.set(entry.target, width);
        changed = true;
      }
    }
    if (changed) schedule();
  });

  function update() {
    queued = false;
    const viewport = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    const stickyHeader = [...document.querySelectorAll('header, .header-wrapper, .header-sticky')]
      .filter(el => ['fixed', 'sticky'].includes(getComputedStyle(el).position))
      .reduce((bottom, el) => Math.max(bottom, Math.min(viewport * .45, el.getBoundingClientRect().bottom)), 0);
    document.querySelectorAll(selector).forEach(nav => {
      if (!nav.closest('.productView') || nav.getBoundingClientRect().width < 1) return;
      if (observer && !widths.has(nav)) {
        widths.set(nav, nav.getBoundingClientRect().width);
        observer.observe(nav);
      }
      const rect = nav.getBoundingClientRect();
      const modal = nav.closest('.halo-quick-view-popup');
      const top = rect.top >= 0 && rect.top < viewport * .65 ? rect.top : (modal ? 48 : stickyHeader + 24);
      const gallery = nav.closest('.productView-images');
      const thumbnails = gallery && gallery.querySelector('.productView-thumbnail-wrapper');
      const vertical = window.innerWidth >= 1024 && nav.closest('.layout-1, .layout-2');
      if (thumbnails) thumbnails.classList.toggle('b2b-compact-thumbnails', !vertical);
      const horizontal = thumbnails && !vertical && thumbnails.getBoundingClientRect().height > 0;
      const controls = horizontal
        ? thumbnails.getBoundingClientRect().height + parseFloat(getComputedStyle(thumbnails).marginTop || 0) + 12
        : 32;
      let budget = Math.max(64, Math.floor(viewport - Math.max(top, modal ? 24 : stickyHeader) - controls - 24));
      let thumbnailChanged = false;
      if (horizontal) {
        const active = nav.querySelector('.productView-image.slick-current .media img:not(.zoomImg)')
          || nav.querySelector('.media img:not(.zoomImg)');
        if (active && active.naturalWidth) {
          const mobile = window.innerWidth < 768;
          const min = mobile ? 56 : 70, max = mobile ? 96 : 150;
          const previousHeight = parseFloat(getComputedStyle(thumbnails.querySelector('.productView-thumbnail-link') || thumbnails).height) || 0;
          const overhead = Math.max(0, thumbnails.getBoundingClientRect().height - previousHeight);
          const pool = Math.max(88, viewport - Math.max(top, modal ? 24 : stickyHeader) - 24
            - parseFloat(getComputedStyle(thumbnails).marginTop || 0) - 12 - overhead);
          const naturalHeight = Math.min(rect.width, active.naturalWidth) * active.naturalHeight / active.naturalWidth;
          // Solve main height + 18% thumbnail height together, then apply bounds.
          const mainHeight = Math.min(naturalHeight, pool / 1.18);
          const thumbnailHeight = Math.round(Math.max(min, Math.min(max, mainHeight * .18)));
          const value = `${thumbnailHeight}px`;
          thumbnailChanged = thumbnails.style.getPropertyValue('--b2b-thumbnail-height') !== value;
          thumbnails.style.setProperty('--b2b-thumbnail-height', value);
          budget = Math.max(64, Math.floor(pool - thumbnailHeight));
        }
      }
      const budgetChanged = nav.style.getPropertyValue('--b2b-media-max-height') !== `${budget}px`;
      nav.style.setProperty('--b2b-media-max-height', `${budget}px`);
      let layoutChanged = budgetChanged || thumbnailChanged || loadedGalleries.has(nav);
      loadedGalleries.delete(nav);
      nav.querySelectorAll('.productView-image').forEach(slide => {
        const image = slide.querySelector('.media img:not(.zoomImg)');
        if (!image || slide.querySelector('video, iframe, model-viewer')) {
          slide.classList.remove('b2b-height-limited');
          return;
        }
        // Bound unloaded slides too; their placeholder must not enlarge the track.
        if (!slide.classList.contains('b2b-height-limited')) layoutChanged = true;
        slide.classList.add('b2b-height-limited');
      });
      if (layoutChanged && nav.classList.contains('slick-initialized') && window.jQuery && window.jQuery.fn.slick) {
        requestAnimationFrame(() => window.jQuery(nav).slick('setPosition'));
      }
    });
  }

  function schedule() {
    if (!queued) {
      queued = true;
      requestAnimationFrame(update);
    }
  }
  document.addEventListener('load', event => {
    if (event.target instanceof HTMLImageElement && event.target.closest('.productView-images')) {
      const nav = event.target.closest(selector);
      if (nav && !event.target.classList.contains('zoomImg')) loadedGalleries.add(nav);
      schedule();
    }
  }, true);
  window.addEventListener('resize', schedule, {passive: true});
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, {passive: true});
  window.addEventListener('load', schedule, {once: true});
  if (document.fonts) document.fonts.ready.then(schedule);
  const start = () => {
    new MutationObserver(records => {
      if (records.some(record => record.type === 'childList' || record.attributeName !== 'class'
        || (record.target.matches('.productView-image')
          && /\bslick-current\b/.test(record.oldValue || '') !== record.target.classList.contains('slick-current')))) schedule();
    }).observe(document.body, {
      childList: true, subtree: true, attributes: true, attributeOldValue: true, attributeFilter: ['src', 'srcset', 'class']
    });
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
